import React, { useEffect, useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";

type Invoice = {
  name: string;
  description: string;
};

const AddProduct = ({
  handleAddPro,
  handleSubmit,
  handleChange,
  sign,
  loading,
}: any) => {
  return (
    <div className="modal">
      <form onSubmit={handleSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Add Product</h4>
          <ImCancelCircle className="catCancel" onClick={handleAddPro} />
        </div>
        <div className="line"></div>
        <div className="catModalInput branchInput">
          <div className="div modalDouble addProduct">
            <input
              type="text"
              placeholder="Product Name*"
              name="name"
              value={sign.name}
              onChange={handleChange}
            />
            <input
              type="text"
              placeholder="Description"
              name="description"
              value={sign.description}
              onChange={handleChange}
            />
          </div>
          <div className="div modalDouble addProduct">
            <input
              type="text"
              placeholder="Quantity*"
              name="quantity"
              value={sign.quantity}
              onChange={handleChange}
            />

            <input
              type="text"
              placeholder="Unit Of Measurment"
              name="unitOfMeasure"
              value="Litre"
              onChange={handleChange}
            />
          </div>
          <input
            type="text"
            placeholder="Selling Price*"
            name="selling"
            value={sign.selling}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="Category"
            name="category"
            value="Oil and Gas"
            onChange={handleChange}
          />
        </div>

        <div className="catModalBtn">
          <button className="catBtn1">
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Add Product"
            )}
          </button>
          <button className="catBtn2" onClick={handleAddPro}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProduct;
